import { Inject, Injectable, NgZone } from '@angular/core';
import { PLATFORM_ID } from '@angular/core';
import posthog from 'posthog-js';
import { environment } from '../../../environments/environment';
import { isPlatformBrowser } from '@angular/common';
@Injectable({ providedIn: 'root' })
export class PosthogService {
    constructor(
        private ngZone: NgZone,
        @Inject(PLATFORM_ID) private platformId: Object,
    ) {
        if (isPlatformBrowser(this.platformId)) {
            this.initPostHog();
        }
    }
    private initPostHog() {
        this.ngZone.runOutsideAngular(() => {
            posthog.init(environment.posthogKey, {
                api_host: environment.posthogHost,
                defaults: '2026-01-30',
                debug: false,
                cross_subdomain_cookie: true,
            });
        });
    }
}
